import React from 'react';
import {
  Button, Input,
} from 'reactstrap';
import axios from 'axios';

const Client = ({
  recruiterOptions, loading, detailsPage, updateOption, updateRecruiter, loaninfo, ...item
}) => {
  const resetPass = async (item) => {
    try {
      // console.log(item);
      await axios.post('/api/resetPassword', { client_id: item._id });
      alert('New password sent successfully');
    } catch (error) {
      console.log(error);
      alert('an error occured');
    }

    // client_id
  };
  const getMethod = (loans) => {
    let repaytype = '';
    loans.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    loans.map((loan) => {
      if (loan) {
        if (loan.status == 7) {
          if (loan.repaymentOption == 'payroll') {
            repaytype = 'payroll';
          } else if (loan.repaymentOption == 'card') {
            repaytype = 'card';
          } else if (loan.repaymentOption == 'direct') {
            repaytype = 'direct';
          }
        }
      }
    });
    return repaytype;
  };
  return (
    <tr onClick={() => detailsPage()}>
      <th scope="row">{item.no}</th>
      <td>
        {' '}
        {item.firstname}
      </td>
      <td>
        {' '}
        {item.lastname}
      </td>
      <td>
        <Input onClick={e => e.stopPropagation()} type="select" name="select" id="exampleSelect" value={item.recruiter} onChange={e => updateRecruiter(item.clientId, e.target.value)}>
          <option value="">none</option>
          {recruiterOptions.map(recruit => (
            <option key={recruit.id} value={recruit.id}>{recruit.name}</option>
          ))}

        </Input>
        {/* {item.clientEmployer} */}
      </td>
      {/* <td>
        {getMethod(loaninfo) ? (<Input type="select" name="select" id="exampleSelect" value={getMethod(loaninfo)} onChange={e => updateOption(item.clientId, e.target.value)}>
          <option value="">none</option>
          <option value="payroll">Payroll Deduction</option>
          <option value="direct">Direct Debit</option>
          <option value="card">Card Payment</option>
        </Input>) : 'No approved loan'}

      </td> */}
      <td>{item.loancount}</td>
      <td><Button onClick={e => e.stopPropagation()} disabled={loading} tag="a" size="sm" href={`/loans/${item.clientId}/${item.firstname} ${item.lastname}`} className="btnprimary" color="info">View Loans</Button></td>
      <td><Button disabled={loading} size="sm" onClick={(e) => { e.stopPropagation(); resetPass(item);}} color="info">Reset Password</Button></td>
    </tr>
  );
};

export default Client;
